import React from 'react'
import { Link } from 'react-router-dom'

function CTAButton() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <section className='cta__section padding__tb'>
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-12 mb-5 mb-lg-0">
                            <div className="cta__section__content">
                                <h2>Receive payments in any African currency, no matter where you are!</h2>
                                <div className='d-flex gap-3 justify-content-center' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CTAButton